import { FC, useContext, useState } from "react";
import {
  MainImageWrapper,
  ImageWrapper,
  ThumbnailWrapper,
  Thumbnail,
  Caption,
  ControlWrapper,
  ButtonlWrapper,
  SeeMoreThumbnail,
  MainImage,
} from "./ImageGallery.styled";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import "react-image-lightbox/style.css";
import GalleryLightBox from "./GalleryLightBox";
import { imageHeroUrl, imageItemUrl } from "common/Utils/images";
import { publicationTypes } from "common/context/Publication/PublicationContext";
import { PublicationContext } from "common/context/Publication";

type Props = {
  hero?: boolean;
  data: {
    title?: string;
    gallery?: {
      data: {
        url: string;
        caption: any;
      };
    }[];
  };
};

const ImageGallery: FC<Props> = ({ data, hero }) => {
  const { gallery } = data;
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const { publication } = useContext<publicationTypes>(PublicationContext);

  if (!gallery) {
    return null;
  }

  const handleSelectThumbNail = (incrementBy: number) => {
    if (gallery[index + incrementBy]) {
      setIndex(index + incrementBy);
    }
  };

  return (
    <>
      <div>
        <ImageWrapper hero={hero}>
          <MainImageWrapper hero={hero}>
            <MainImage
              src={`${imageHeroUrl(publication, gallery[index].data?.url)}`}
            />
            <ControlWrapper>
              <ButtonlWrapper
                disabled={index === 0}
                onClick={() => setIndex(index - 1)}
              >
                <AiOutlineLeft />
              </ButtonlWrapper>
              <ButtonlWrapper
                disabled={index === gallery.length - 1}
                onClick={() => setIndex(index + 1)}
              >
                <AiOutlineRight />
              </ButtonlWrapper>
            </ControlWrapper>
          </MainImageWrapper>

          <ThumbnailWrapper>
            <Thumbnail
              image={
                gallery[1] &&
                `${imageItemUrl(publication, gallery[1].data?.url, 3)}`
              }
              onClick={() => gallery[1] && setIndex(1)}
            />
            <Thumbnail
              image={
                gallery[2] &&
                `${imageItemUrl(publication, gallery[2].data?.url, 3)}`
              }
              onClick={() => gallery[2] && setIndex(2)}
            />
            <SeeMoreThumbnail
              onClick={() => setOpen(true)}
              image={
                gallery[3] &&
                `${imageItemUrl(publication, gallery[3].data?.url, 3)}`
              }
            >
              {gallery && gallery.length > 3 && (
                <p>
                  {" "}
                  + {gallery.length - 3} <br />
                  (View All)
                </p>
              )}
            </SeeMoreThumbnail>
          </ThumbnailWrapper>
        </ImageWrapper>

        <Caption>
          {" "}
          {gallery[index].data &&
            gallery[index].data.caption &&
            gallery[index].data.caption}
        </Caption>
      </div>
      <GalleryLightBox
        setIndex={setIndex}
        index={index}
        gallery={gallery}
        setOpen={setOpen}
        open={open}
      />
    </>
  );
};

export default ImageGallery;
